/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AdditionalBillingProfileAddress } from './';
import {
    AdditionalBillingProfileAddressFromJSON,
    AdditionalBillingProfileAddressFromJSONTyped,
    AdditionalBillingProfileAddressToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateAdditionalBillingProfileRequest
 */
export interface CreateAdditionalBillingProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAdditionalBillingProfileRequest
     */
    label: string;
    /**
     * 
     * @type {AdditionalBillingProfileAddress}
     * @memberof CreateAdditionalBillingProfileRequest
     */
    address: AdditionalBillingProfileAddress;
    /**
     * 
     * @type {string}
     * @memberof CreateAdditionalBillingProfileRequest
     */
    registrationNumber?: string;
}

/**
 * Check if a given object implements the CreateAdditionalBillingProfileRequest interface.
 */
export function instanceOfCreateAdditionalBillingProfileRequest(value: object): value is CreateAdditionalBillingProfileRequest {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function CreateAdditionalBillingProfileRequestFromJSON(json: any): CreateAdditionalBillingProfileRequest {
    return CreateAdditionalBillingProfileRequestFromJSONTyped(json, false);
}

export function CreateAdditionalBillingProfileRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAdditionalBillingProfileRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'address': AdditionalBillingProfileAddressFromJSON(json['address']),
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
    };
}

export function CreateAdditionalBillingProfileRequestToJSON(value?: CreateAdditionalBillingProfileRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'address': AdditionalBillingProfileAddressToJSON(value['address']),
        'registrationNumber': value['registrationNumber'],
    };
}

